import { compareAnnouncements } from './announcementsService';

// eslint-disable-next-line no-magic-numbers
const minInterval = 1000 * 60;
// eslint-disable-next-line no-magic-numbers
const maxInterval = 1000 * 60 * 3;

export default class AnnouncementMonitor {
	constructor(getActiveAnnouncements, removeAnnouncement, addAnnouncement) {
		this.monitoredAnnouncements = new Map();
		this.cycleTimeout = null;
		this.cycling = false;
		this.getActiveAnnouncements = getActiveAnnouncements;
		this.removeAnnouncement = removeAnnouncement;
		this.addAnnouncement = addAnnouncement;
	}

	observe(announcement) {
		this.monitoredAnnouncements.set(announcement.uuid, announcement);
	}

	unobserve(announcementId) {
		this.monitoredAnnouncements.delete(announcementId);
	}

	getAnnouncement(announcementId) {
		return this.monitoredAnnouncements.get(announcementId);
	}

	start() {
		if (!this.cycling || !this.cycleTimeout) {
			this.cycling = true;
			this.cycleTimeout = setTimeout(this.cycle.bind(this), this.getNextInterval());
		}
	}
	
	stop() {
		this.cycling = false;
		clearTimeout(this.cycleTimeout);
		this.cycleTimeout = null;
	}

	cycle() {
		clearTimeout(this.cycleTimeout);

		const that = this;
		this.getActiveAnnouncements((announcements) => {
			const nextAnnouncements = new Map(announcements.map(a => [a.uuid, a]));

			const announcementsToAdd = Array.from(nextAnnouncements.values()).filter(a => 
				!that.monitoredAnnouncements.has(a.uuid));

			const announcementsToRemove = Array.from(that.monitoredAnnouncements.keys()).filter(aId => 
				!nextAnnouncements.has(aId));

			const announcementsToChange = Array.from(nextAnnouncements.values()).filter(a => 
				that.monitoredAnnouncements.has(a.uuid) 
				&& !compareAnnouncements(a, that.monitoredAnnouncements.get(a.uuid)));

			for (const announcement of announcementsToAdd) {
				that.addAnnouncement(announcement);
			}

			for (const announcement of announcementsToChange) {
				that.removeAnnouncement(announcement.uuid);
				that.addAnnouncement(announcement);
			}

			for (const announcementId of announcementsToRemove) {
				that.removeAnnouncement(announcementId);
			}
		});

		if (this.cycling) {
			this.cycleTimeout = setTimeout(this.cycle.bind(this), this.getNextInterval());
		}
	}

	getNextInterval() {
		return Math.floor(Math.random() * (maxInterval - minInterval) + minInterval); 
	}
}
